import { Firm } from '@/_types/models/firm';
import { Questionnaire } from '@/_types/models/questionnaire';
import { moment, type Moment } from '@/_utils/dates';

// TODO(API) @chris to move away from moment, we'd need to migrate timezones saved to IANA Time Zone Database format
// TODO(API) @chris should be coming from the api to be sure reminder dates match

// NOTE @chris these are from the old app

const _getReminderDate = (newDate: Moment): Moment => {
  return newDate.isBefore(moment())
    ? moment().utc().hours() < 10
      ? moment()
      : moment().add(1, 'days')
    : newDate.startOf('day');
};

export const getNextReminderDateString = (
  questionnaire: Questionnaire,
  currentUserFirm?: Firm,
): string | null => {
  if (
    !questionnaire.due_date ||
    questionnaire.locked ||
    questionnaire.reminders_disabled ||
    questionnaire.completed
  ) {
    return null;
  }

  const baseDate: Moment = moment(
    questionnaire.last_followed_up
      ? questionnaire.last_followed_up
      : questionnaire.sent_at,
  );
  const reminderFrequency: number =
    currentUserFirm?.questionnaire_reminder_frequency ?? 0;
  const newDate: Moment = baseDate.add(reminderFrequency, 'day');
  const reminderDate = _getReminderDate(newDate);

  const momentToday: Moment = moment().startOf('day');
  const momentDueDate: Moment = moment(questionnaire.due_date, 'YYYY-MM-DD');
  const earliestReminderMoment = moment(
    questionnaire.earliest_remind_date,
    'YYYY-MM-DD',
  );

  // prettier-ignore
  if (
    (
      !questionnaire.earliest_remind_date ||
      (
        questionnaire.earliest_remind_date &&
        earliestReminderMoment.isBefore(reminderDate)
      )
    ) && reminderDate.isBefore(momentDueDate)
  ) {
    return moment(reminderDate.toISOString(), moment.ISO_8601).format('ll');
  }

  // prettier-ignore
  if (
    questionnaire.earliest_remind_date &&
    earliestReminderMoment.isBefore(momentDueDate) &&
    (
      earliestReminderMoment.isAfter(reminderDate) ||
      earliestReminderMoment.isSame(reminderDate)
    )
  ) {
    return moment(earliestReminderMoment.toISOString(), moment.ISO_8601).format(
      'll',
    );
  }

  // prettier-ignore
  if (
    questionnaire.earliest_remind_date &&
    earliestReminderMoment.isAfter(reminderDate) &&
    earliestReminderMoment.isAfter(momentDueDate) &&
    momentDueDate.clone().subtract(3, 'days').isAfter(momentToday)
  ) {
    return moment(
      momentToday.toISOString(),
      moment.ISO_8601,
    ).format('ll');
  }

  return null;
};
